import { format, parseISO } from "date-fns";

export const formatDate = (date) => format(parseISO(date),'EEE do MMM');
export const formatDateWithTime = (date) => format(parseISO(date),'EEE do MMM HH:mm a');